import { useContext } from 'react'

import { Form } from 'components/ui/form/Form'
import { userValidation } from 'util/validations'
import { useCreateUser } from 'hooks/mutations'
import { UserPlusIcon } from '@heroicons/react/24/outline'
import { ModalContext } from 'context/ModalContext'
import { Card } from 'components/gsys-ui'
import UserForm from './UserForm'

const AddUserModal = ({ initial }) => {
  const modal = useContext(ModalContext)
  const mutation = useCreateUser()

  return (
    <Card className="m-auto">
      <Card.Title Icon={UserPlusIcon}>Add a user</Card.Title>
      <Card.Body>
        <Form
          validation={userValidation}
          initial={initial}
          mutation={mutation}
          FormComp={UserForm}
          onSubmit={modal.close}
        />
      </Card.Body>
    </Card>
  )
}

export default AddUserModal